// extracted by mini-css-extract-plugin
export var displayNone = "_rp-6";
export var imgContainer = "_rp-2";
export var overflowHidden = "_rp-3";
export var productInfoCardButtonContainer = "_rp-5";
export var productTitleText = "_rp-4";
export var rightArrow = "_rp-1";
export var rightArrowContainer = "_rp-0";